import { faqCelular, faqCusto, faqProgramar } from './shared'
import type { ProfessionPageConfig } from './types'

export const pequenosNegocios: ProfessionPageConfig = {
  path: '/ia-para-pequenos-negocios/',
  key: 'negocio',
  title: 'IA para pequenos negócios e MEI, sem programar | Oficina IA',
  description:
    'Três tarefas do dono de pequeno negócio que a IA adianta numa pasta: orçamentos e recibos, a planilha de clientes e a pasta do mês para o contador.',
  imageAlt: 'Oficina IA: IA para pequenos negócios e MEI',
  whatsappMessage: 'Olá, Arthur. Vim pela página de IA para pequenos negócios e quero saber sobre o acompanhamento.',
  lastmod: '2026-09-25',
  heading: 'IA para pequenos negócios e MEI',
  intro:
    'Você faz tudo, inclusive o administrativo à noite. Ouve que "a IA resolve" e não sabe por onde começar. Aqui estão três tarefas desse administrativo que a IA pode ajudar a adiantar, sem programar.',
  rogerio: { pose: 'animado', text: 'O administrativo da noite dá para encurtar.' },
  tasks: [
    {
      title: 'Orçamentos e recibos',
      tone: 'sky',
      brings: 'um modelo e a lista de clientes.',
      helps: 'preenche o orçamento ou o recibo com os dados certos e salva na pasta.',
      continues: 'confere e manda.',
    },
    {
      title: 'A planilha de clientes',
      tone: 'peach',
      brings: 'as conversas e as anotações espalhadas.',
      helps: 'monta a planilha: quem comprou, quando, o que pediu.',
      continues: 'usa para lembrar e para cobrar.',
    },
    {
      title: 'A pasta do mês para o contador',
      tone: 'sage',
      brings: 'notas e comprovantes do mês, misturados.',
      helps: 'renomeia, separa e faz a lista do que tem.',
      continues: 'manda a pasta pronta, e o contador agradece.',
    },
  ],
  steps: {
    do: 'A IA preenche, organiza ou monta a planilha dentro da sua pasta.',
    check: 'Confira os valores e os nomes antes de mandar. A IA pode se enganar; o negócio é seu.',
    resume: 'No mês seguinte, troque os arquivos e repita o pedido.',
  },
  faq: [
    faqProgramar,
    {
      question: 'Preciso ter empresa aberta?',
      answer: 'As tarefas desta página valem para qualquer pessoa que trabalhe por conta própria, com ou sem CNPJ.',
    },
    faqCelular,
    faqCusto,
  ],
  closing: {
    title: 'Seu primeiro mês organizado, com alguém do lado.',
    text: 'Traga o orçamento, a planilha de clientes ou a pasta do contador.',
    rogerio: 'Eu cuido do novelo. Você cuida do negócio.',
  },
}
